import Select from "react-select";
import axios from "axios";
import { useState, useEffect } from "react";
import DropdownCaret from "../../ui/select/DropDown";

export const SpecialtiesSelector = ({
  specialties,
  selectedSpecialties,
  onChange,
}) => {
  // Filtrar solo las especialidades que vienen del endpoint
  const filteredOptions = specialties.filter((specialtie) =>
    selectedSpecialties.includes(specialtie.id)
  );
  const options = specialties.map((specialtie) => ({
    value: specialtie.id,
    label: specialtie.nombre,
  }));

  const defaultValue = filteredOptions.map((specialtie) => ({
    value: specialtie.id,
    label: specialtie.nombre,
  }));

  const handleSelectChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    onChange(selectedIds);
  };
  function useIsSmallScreen(breakpoint = 480) {
    const [isSmall, setIsSmall] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => setIsSmall(window.innerWidth <= breakpoint);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isSmall;
  }

  const isSmallScreen = useIsSmallScreen(480);

  return (
    <div
      style={{
        width:
          window.innerWidth <= 480
            ? "auto" // móvil
            : window.innerWidth <= 1024
            ? "250px" // tablet
            : "500px", // desktop
        overflow: "visible",
        height: "auto",
      }}
    >
      <Select
        options={options}
        isMulti
        components={{ DropdownIndicator: DropdownCaret }}
        styles={{
          valueContainer: (provided) => ({
            ...provided,
            flexWrap: "wrap",
            overflow: "visible", // Permite crecer sin scroll
            minHeight: "40px",
            height: "auto", // Deja que crezca automáticamente
          }),
          control: (provided, state) => ({
            ...provided,
            minHeight: "40px",
            overflowY: "visible",
            height: "auto",
            flexWrap: "wrap", // <-- permite que crezca
            whiteSpace: "normal", // <-- permite múltiples líneas
            backgroundColor: "#fff",
            borderColor: state.isFocused ? "#62C776" : "#ccc",
            boxShadow: state.isFocused ? "0 0 3px #62C776" : "none",
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          menuList: (provided) => ({
            ...provided,
            textAlign: "left",
            maxHeight: "200px",
            overflowY: "auto",
            color: "#223d51",
          }),
          option: (provided, state) => ({
            ...provided,
            color: "#000",
            backgroundColor: state.isSelected ? "#e0e0e0" : "white",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }),
          multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#62C776",
            color: "#fff",
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            color: "#fff",
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            color: "#fff",
            ":hover": {
              backgroundColor: "#ff6b6b",
              color: "#fff",
            },
          }),
        }}
        value={defaultValue}
        onChange={handleSelectChange}
        placeholder="Selecciona especialidades"
        classNamePrefix="react-select"
      />
    </div>
  );
};

const obtenerContratoRelevante = (documentos) => {
  // Filtrar solo los contratos
  const contratos = documentos.filter(
    (doc) => doc.tipoDocumento.lenguaje === "CONTRACT"
  );

  // Buscar contrato vigente
  const contratoVigente = contratos.find(
    (doc) => doc.vigencia.lenguaje === "VALID"
  );
  if (contratoVigente) {
    return contratoVigente;
  }

  // Si no hay contratos vigentes, buscar el último expirado con la fecha más reciente
  const contratosExpirados = contratos
    .filter((doc) => doc.vigencia.lenguaje === "EXPIRED")
    .sort((a, b) => b.fechaVencimiento - a.fechaVencimiento); // Ordenar de más reciente a más antiguo

  return contratosExpirados.length > 0 ? contratosExpirados[0] : null;
};

export const fetchContratosPorEmpresa = async (API_URL, empresaId) => {
  try {
    const response = await axios.get(`${API_URL}/api/contratos-empresa`, {
      params: { empresaId }, // Parámetro en la URL
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });

    return obtenerContratoRelevante(response.data);
  } catch (error) {
    console.error("Error al obtener contratos por empresa:", error);
    throw error;
  }
};

export const habilitarEmpresa = async (API_URL, empresaId) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/empresas-h?empresaId=${empresaId}`,
      {},
      { withCredentials: true }
    );

    return response.data;
  } catch (error) {
    return null;
  }
};

export const deshabilitarEmpresa = async (API_URL, empresaId) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/empresas-inh?empresaId=${empresaId}`,
      {},
      { withCredentials: true }
    );

    return response.data;
  } catch (error) {
    return null;
  }
};
